import { StyleSheet } from "aphrodite";
import { space } from "main/javascripts/styles/base/spaceStyle";
import { borderRadius } from "main/javascripts/styles/base/borderStyle";

interface IStyle {
  googleMap: any;
}

export const mapContainerStyle = {
  top: 0,
  left: 0,
};

export const GoogleMapStyle: IStyle = StyleSheet.create({
  googleMap: {
    margin: space.atom,
    width: "auto",
    paddingTop: "50%",
    borderRadius: borderRadius.normal,
    position: "relative",
  },
});
